module.exports = __webpack_public_path__ + "img/render.604a5df7.png";